import { takeLatest } from 'redux-saga/effects';
import callRequestSaga from '~/sagas/utils/request-saga';
import UserManagementSubmenuConstants from '~/components/containers/UserManagementSubmenuContainer/constants';
import RolesAPI from '~/api/roles-api';

export function* getUserManagementSubmenu() {
  yield* callRequestSaga(RolesAPI.getUserManagementSubmenu, {
    request: UserManagementSubmenuConstants.GET_USER_MANAGEMENT_SUBMENU_REQUEST,
    success:
      UserManagementSubmenuConstants.GET_USER_MANAGEMENT_SUBMENU_REQUEST_SUCCESS,
    failure:
      UserManagementSubmenuConstants.GET_USER_MANAGEMENT_SUBMENU_REQUEST_ERROR,
  });
}

export function* getUserManagementSubmenuSaga() {
  yield takeLatest(
    UserManagementSubmenuConstants.GET_USER_MANAGEMENT_SUBMENU,
    getUserManagementSubmenu
  );
}

export default [getUserManagementSubmenuSaga];
